import { toast as sonner } from 'sonner';
import i18n from 'i18next';
import { CheckCircle, Info, XCircle, AlertTriangle } from 'lucide-react';


const TITLES = {
  info: 'Notice!',
  success: 'Success!',
  warning: 'Attention!',
  danger: 'Error!',
};

const ICONS = {
  info: <Info size={22} className="text-blue-500" />,
  success: <CheckCircle size={22} className="text-green-500" />,
  warning: <AlertTriangle size={22} className="text-yellow-500" />,
  danger: <XCircle size={22} className="text-red-500" />,
};

const ALIASES = {
  warn: 'warning',
  error: 'danger',
};

const normalize = (type) => {
  const resolved = ALIASES[type] ?? type;

  return resolved in TITLES ? resolved : 'info';
};

const readingTime = (message) => Math.max(Math.min(message.length * 50, 60 * 1000), 5000);

const openNotification = (message, type, duration, placement) => {
  const resolved = normalize(type);
  const text = i18n.t(message);

  return sonner(i18n.t(TITLES[resolved]), {
    type: resolved,
    icon: ICONS[resolved],
    position: placement || 'bottom-center',
    description: text,
    duration: duration || readingTime(text),
  });
};

const openActionNotification = ({ id, title, message, icon, action, duration = 15000, placement = 'top-right' }) => sonner(i18n.t(title), {
  id,
  icon,
  description: i18n.t(message),
  position: placement,
  duration,
  action,
  closeButton: true,
});

const updateNotification = (key, message, type) => {
  const resolved = normalize(type);

  return sonner(i18n.t(TITLES[resolved]), {
    id: key,
    type: resolved,
    icon: ICONS[resolved],
    description: i18n.t(message),
  });
};

const removeNotification = (key) => sonner.dismiss(key);

const openNotifications = async (messages, duration) => {
  for (const msg of messages) {
    await new Promise(resolve => setTimeout(resolve, 100));

    if (msg.type === 'debug') {
      continue;
    }

    openNotification(msg.message, msg.type, duration);
  }
};

export { openNotification, openActionNotification, updateNotification, removeNotification, openNotifications };
